import { SVGProps } from 'react';

const IcTickV3 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        d='M9.20554 19.3762C8.81194 19.3762 8.43803 19.2116 8.16252 18.9234L2.59307 13.0986C2.02236 12.5017 2.02236 11.5137 2.59307 10.9169C3.16378 10.32 4.10841 10.32 4.67912 10.9169L9.20554 15.6508L19.3209 5.07145C19.8916 4.47456 20.8362 4.47456 21.4069 5.07145C21.9776 5.66834 21.9776 6.65629 21.4069 7.25318L10.2486 18.9234C9.97305 19.2116 9.59913 19.3762 9.20554 19.3762Z'
        fill={props.fill || '#232F3E'}
      />
    </svg>
  );
};

export default IcTickV3;
